import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  const navigate = useNavigate();
  return <footer className="w-full bg-neutral-900 text-neutral-400 py-16 px-6" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        {/* Top: Brand + Nav */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center pb-10 border-b border-neutral-800" data-id="element-20">
          <div className="mb-6 md:mb-0" data-id="element-21">
            <h1 className="text-white font-medium text-xl tracking-wide" data-id="element-22">
              Stasis Group
            </h1>
          </div>
          <div className="flex flex-wrap gap-8 text-sm" data-id="element-23">
            <button onClick={() => navigate('/projects')} className="hover:text-white transition-colors" data-id="element-24">

              Projects
            </button>
            <button onClick={() => navigate('/refund-policy')} className="hover:text-white transition-colors" data-id="element-25">

              Refund Policy
            </button>
            <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors" data-id="element-26">

              Terms of Use
            </button>
            <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors" data-id="element-27">

              Privacy Policy
            </button>
            <a href="https://cal.com/stasis-group-africa/15min" target="_blank" className="hover:text-white transition-colors" data-id="element-28">

              Contact us
            </a>
          </div>
        </div>

        {/* Middle: Contact Info */}
        <div className="py-10 border-b border-neutral-800" data-id="element-29">
          <h4 className="text-white text-sm font-medium uppercase tracking-wider mb-6" data-id="element-30">
            Contact
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm" data-id="element-31">
            <div className="flex items-start gap-3" data-id="element-32">
              <Mail className="w-4 h-4 text-neutral-500 mt-0.5 flex-shrink-0" data-id="element-33" />
              <div data-id="element-34">
                <a href="mailto:hello@stasisgroup.co" className="hover:text-white transition-colors" data-id="element-35">

                  hello@stasisgroup.co
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-36">
              <Phone className="w-4 h-4 text-neutral-500 mt-0.5 flex-shrink-0" data-id="element-37" />
              <div data-id="element-38">
                <a href="tel:+27724473317" className="hover:text-white transition-colors" data-id="element-39">+27724473317
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-40">
              <MapPin className="w-4 h-4 text-neutral-500 mt-0.5 flex-shrink-0" data-id="element-41" />
              <span data-id="element-42">Alberton, Johannesburg, South Africa</span>
            </div>
          </div>
        </div>

        {/* Bottom: Business Info + Copyright */}
        <div className="pt-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-neutral-600" data-id="element-43">
          <span data-id="element-44">Stasis Group PTY LTD. 2023/889768/07</span>
          <span data-id="element-45">
            © {new Date().getFullYear()} Stasis Group. All rights reserved.
          </span>
        </div>
      </div>
    </footer>;
}